import React from "react";

export const AuthProtectedContext = React.createContext();